import * as React from "react";
import FSNotifierStore from "../../components/Notifier/store";

const LoginPageContext = React.createContext<{
  addNotice: FSNotifierStore["addNotice"];
  mobileStep: number;
  setMobileStep: React.Dispatch<React.SetStateAction<number>>;
  isCustom: boolean;
}>(null);

export { LoginPageContext };
